import React, {useEffect, useRef} from 'react';
import Default from './layouts/Default/Default';
import Confirm from './layouts/Confirm/Confirm';

const Notification = ({
						  visible = false,
						  onClose = null,
						  duration = 0, // 0 = permanent, otherwise ms
						  layout = '',
						  color = '',
						  text = '',
						  children = null,
						  confirmText = '',
						  onConfirm = null,
						  cancelText = '',
						  onCancel = null,
					  }) => {

	// Keep the latest onClose in a ref so timer effect doesn't restart on every parent render
	const onCloseRef = useRef(onClose);
	useEffect(() => {
		onCloseRef.current = onClose;
	}, [onClose]);

	useEffect(() => {
		if (!visible || !duration) {
			return;
		}

		const timer = setTimeout(() => {
			if (typeof onCloseRef.current === 'function') {
				onCloseRef.current();
			}
		}, duration);

		return () => clearTimeout(timer);
	}, [visible, duration]);

	if (!visible) {
		return null;
	}

	const layouts = {
		Default,
		Confirm,
	};
	const LayoutComponent = layouts[layout] ?? Default;

	return (
	  <LayoutComponent
		text={text}
		color={color}
		onClose={onClose}
		duration={duration}
		confirmText={confirmText}
		onConfirm={onConfirm}
		cancelText={cancelText}
		onCancel={onCancel}
	  >
		  {children}
	  </LayoutComponent>
	);
};

export default Notification;
